import React from 'react';
import {useDispatch} from 'react-redux';

import {useDocumentViewer} from '../../context/DocumentViewerContext';
import {downloadDocs, initialize as initializeDownload} from '../../modules/chat/download';

import {Box, Button, IconButton, MenuItem, Select, Stack, Typography} from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import FileDownloadIcon from '@mui/icons-material/FileDownload'; 

export default function DocumentHeader({ fileName, sheetName, downloadLink }) {
    const dispatch = useDispatch();

    const { documentList, currentDocumentIndex, closeRightSideBar, switchDocument } = useDocumentViewer();

    const isMultiDocument = documentList.length > 1;

    // sheetName이 None인 경우 빈 문자열로 처리, 아닌 경우 그대로 사용
    const normalizeSheetName = (sheetName) => (sheetName && sheetName !== 'None' ? sheetName : '');
    
    // 확장자 분리
    const splitExtension = (name) => {
        const i = name.lastIndexOf('.');

        return i < 0 ? { base: name, extension: '' } : { base: name.slice(0, i), extension: name.slice(i) };
    };

    const displayName = (fileName, sheetName, maxLength = 36) => {
        const { base, extension } = splitExtension(fileName);
        const filePart = base.length > maxLength ? `${base.slice(0, maxLength)}…${extension}` : `${base}${extension}`;
        const sheetPart = normalizeSheetName(sheetName);
        
        return sheetPart ? `${filePart} > ${sheetPart}` : filePart;
    };

    const downloadDocument = () => {
        if (!downloadLink) return;

        dispatch(downloadDocs({ downloadLink }));
        dispatch(initializeDownload());
    };

    return (
        <Stack
            sx={{ width: '100%', p: '20px 40px' }}
            spacing={2}
        >
            <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px' }}>
                {isMultiDocument
                    ? <Select
                        variant='outlined'
                        size='small'
                        sx={{ width: '100%' }}
                        value={currentDocumentIndex}
                        onChange={(e) => switchDocument(e.target.value)} // e.target.value는 MenuItem의 value
                    >
                        {documentList.map((document, index) => (
                            <MenuItem key={index} value={index}>
                                {displayName(document.fileName, document.sheetName, 32)}
                            </MenuItem>
                        ))}
                    </Select>
                    : <Typography variant='body2' sx={{ width: '100%' }}>
                        {displayName(fileName, sheetName, 36)}
                    </Typography>
                }
                <IconButton
                    size='medium'
                    onClick={closeRightSideBar}
                >
                    <CloseRoundedIcon />
                </IconButton>
            </Box>
            <Button
                sx={{ alignSelf: 'flex-start' }}
                size='small'
                variant='text'
                startIcon={<FileDownloadIcon />}
                onClick={downloadDocument}
            >
                다운로드
            </Button>
        </Stack>
    );
}
